let icons = {
  /* articleTitleImg: require('../assets/icons/article-title-img.png'),
  // article: require('../assets/icons/icon-article.png'),
  // video: require('../assets/icons/icon-video.png'),
  audioCom: require('../assets/icons/audioCom.png'), // 云端稿库-音频稿件icon
  top: require('../assets/icons/icon-top.png'),
  relevance: require('../assets/icons/icon-relevance.png'),
  // link: require('../assets/icons/icon-link.png'),
  // lock: require('../assets/icons/icon-lock.png'),
  app: require('../assets/icons/icon_APP.png'),
  bbs: require('../assets/icons/icon_BBS.png'),
  wechat: require('../assets/icons/icon_wechat.png'),
  weibo: require('../assets/icons/icon_blog.png'),
  weibobig: require('../assets/icons/weibobig.png'),
  weiboLogo: require('../assets/icons/weiboLogo.png'),
  epaper: require('../assets/icons/icon_epaper.png'),
  paper: require('../assets/icons/paper.png'),
  news: require('../assets/icons/icon_web.png'),
  xy: require('../assets/icons/xy.png'),
  dep: require('../assets/icons/dep.png'),
  tvArticle: require('../assets/icons/tvArticleLogo.png'),
  wemedia: require('../assets/icons/icon_wemedia.png'),
  no_result: require('../assets/icons/42.png'),
  noVoiceResult: require('../assets/icons/noVoiceResult.png'),
  saveVoice: require('../assets/icons/save_voice.png'),
  editVoice: require('../assets/icons/edit_voice.png'),
  sensitiveFlag: require('../assets/icons/sensitive_icon.png'),
  dispatching: require('../assets/icons/icon_assign.png'),
  choose: require('../assets/icons/icon_choose.png'),
  modify: require('../assets/icons/icon_modify.png'),
  transmit: require('../assets/icons/icon_forward.png'),
  turntopic: require('../assets/icons/icon_xuanti.png'),
  // pic: require('../assets/icons/icon-article-photo.png'),
  copyright: require('../assets/icons/23.png'),
  search: require('../assets/icons/25.png'),
  iconSearch: require('../assets/icons/icon-search.png'),
  viewLog: require('../assets/icons/icon_viewLog.png'),
  add: require('../assets/icons/add.png'),
  circledCross: require('../assets/icons/circled-cross.png'),
  close: require('../assets/icons/close.png'),
  delete: require('../assets/icons/delete.png'),
  edit: require('../assets/icons/edit.png'),
  largeAdd: require('../assets/icons/large-add.png'),
  last: require('../assets/icons/last.png'),
  leftArrow: require('../assets/icons/left-arrow.png'),
  next: require('../assets/icons/next.png'),
  rightArrow: require('../assets/icons/right-arrow.png'),
  _edit: require('../assets/icons/icon_edit.png'),
  _edit_selected: require('../assets/icons/icon_edit_selected.png'),
  set: require('../assets/icons/icon_set.png'),
  set_selected: require('../assets/icons/icon_set_selected.png'),
  uploadDelete: require('../assets/icons/icon-upload-delete.png'),
  uploadStart: require('../assets/icons/icon-upload-start.png'),
  uploadStop: require('../assets/icons/icon-upload-stop.png'),
  uploadRetry: require('../assets/icons/icon-upload-retry.png'),
  uploadCompress: require('../assets/icons/icon-upload-compress.png'),
  chooseAdd: require('../assets/icons/choose.png'),
  videoPlay: require('../assets/icons/video.png'), // 视频
  videoPlayBlack: require('../assets/icons/videoPlayBlack.png'), // 视频
  defaultHeadPhoto: require('../assets/img/def.png'),
  related: require('../assets/icons/related.png'),
  unrelated: require('../assets/icons/unrelated.png'),
  chosed: require('../assets/icons/chosed.png'),
  unchosed: require('../assets/icons/unchosed.png'),
  // 图片视频预览所需图标
  previewEdit: require('../assets/icons/icon_preview_edit.png'), // 编辑
  previewEditDisabled: require('../assets/icons/icon_edit_disabled.png'), // 禁用编辑
  previewLarge: require('../assets/icons/icon_add.png'), // 放大
  previewDrag: require('../assets/icons/icon_drag.png'), // 拖拽
  previewDelete: require('../assets/icons/icon_delete.png'), // 删除
  stepOneDefault: require('../assets/icons/43.png'), // 第一步默认
  stepOneActive: require('../assets/icons/44.png'), // 第一步活动
  stepTwoDefault: require('../assets/icons/45.png'), // 第二步默认
  stepTwoActive: require('../assets/icons/46.png'), // 第二部默认
  specialSample: require('../assets/icons/specialSample.png'), // 专题稿件样例图片
  liveSample: require('../assets/icons/liveSample.png'), // 直播稿件样例图片
  tick: require('../assets/icons/47.png'),
  newAddRole: require('../assets/icons/newAddRole.png'), // 新增角色
  copy: require('../assets/icons/48.png'), // 复制
  // download: require('../assets/icons/34.png'), // 下载
  warning: require('../assets/icons/49.png'), // 警告
  audio: require('../assets/icons/50.png'), // 音频
  expose: require('../assets/icons/51.png'), // 被举报
  officialReply: require('../assets/icons/52.png'), // 官方回复
  releaseEndVersionDetail: require('../assets/icons/53.png'), // 系统管理端-发布端概览-版本管理—列表详情图标
  frozen: require('../assets/icons/lock.png'), // 用户冻结状态图标
  app_icon: require('../assets/icons/app_icon.png'), // 用户冻结状态图标
  // android: require('../assets/icons/android-icon.png'), // 安卓
  // ios: require('../assets/icons/ios-icon.png'), // ios
  ucDetailDefault: require('../assets/icons/uc-detail-default.png'), // ios
  addOptions: require('../assets/icons/54.png'),
  deleteOptions: require('../assets/icons/55.png'),
  downloadIcon: require('../assets/icons/56.png'), // 另一个样式的下载图标
  chevronSmallDown: require('../assets/icons/chevron-small-down.png'), // 展开
  chevronSmallUp: require('../assets/icons/chevron-small-up.png'), //  收缩
  // userDelete: require('../assets/icons/icon-upload-delete.png'), //  操作删除用户
  // userDetail: require('../assets/icons/53.png'), //  操作用户详情
  // userColumnPermission: require('../assets/icons/user-column-permission.png'), //  操作栏目权限
  // userRoleConfig: require('../assets/icons/user-role-config.png'), //  操作角色设置
  tableModify: require('../assets/icons/30.png'), //  修改用户
  tableDel: require('../assets/icons/delete2.png'), //  修改角色
  noMember: require('../assets/icons/noMember.png'), //  无成员
  roleSet: require('../assets/icons/roleSet.png'), //  修改角色
  taskAssign: require('../assets/icons/taskAssign.png'), //  指挥策划列表-派工
  topicDelete: require('../assets/icons/topicDelete.png'), //  指挥策划列表-删除
  topicEdit: require('../assets/icons/topicEdit.png'), //  指挥策划列表-编辑
  // appPreview: require('../assets/icons/appPreview.png'), //  内容发布-预览

  preview: require('../assets/icons/appPreview.png'), //  通用预览
  config: require('../assets/icons/siteEdit.png'), //  通用设置
  deleteBlue: require('../assets/icons/topicDelete.png'), //  通用删除 蓝色小盖子

  // 大屏缩略图
  '01_lead_page': require('../assets/img/bigscreen/01_lead_page.jpg'), // 01大屏总领页
  '02_sub_topic': require('../assets/img/bigscreen/02_sub_topic.jpg'), // 02区县选题
  '03_map': require('../assets/img/bigscreen/03_map.jpg'), // 03地图模式
  '04_newsplan': require('../assets/img/bigscreen/04_newsplan.jpg'), // 04策划中心
  '05_rootarticle': require('../assets/img/bigscreen/05_rootarticle.jpg'), // 05稿源中心
  '06_mam_1': require('../assets/img/bigscreen/06_mam_1.jpg'), // 06 媒资库1.1
  '06_mam_2': require('../assets/img/bigscreen/06_mam_2.jpg'), // 06媒资库1.2
  '07_appArticle': require('../assets/img/bigscreen/07_appArticle.jpg'), // 07发布库
  '08_command_map': require('../assets/img/bigscreen/08_command_map.jpg'), // 08指令地图
  '09_rr_AMArticle': require('../assets/img/bigscreen/09_rr_AMArticle.jpg'), // 09云端稿库-权威推荐

  // appEdit: require('../assets/icons/topicEdit.png'), //  内容发布-修改
  // discussPass: require('../assets/icons/discussPass.png'), //  评论管理-通过
  discussStatePass: require('../assets/icons/discussStatePass.png'), //  评论管理-状态-通过
  discussStatePendingApproval: require('../assets/icons/discussStatePendingApproval.png'), //  评论管理-状态-待审核
  discussStateReject: require('../assets/icons/discussStateReject.png'), //  评论管理-状态-不通过
  // discussReject: require('../assets/icons/discussReject.png'), //  评论管理-不通过
  // discussReplied: require('../assets/icons/discussReplied.png'), //  评论管理-官方回复-已回复
  // discussReply: require('../assets/icons/discussReply.png'), //  评论管理-官方回复
  // mamDetail: require('../assets/icons/mamDetail.png'), //  媒资-详情
  // mamDelete: require('../assets/icons/mamDelete.png'), //  媒资-删除
  // mamCheck: require('../assets/icons/mamCheck.png'), //  媒资-智能检测

  // ucPreview: require('../assets/icons/appPreview.png'), //  会员-详情
  // ucEdit: require('../assets/icons/topicEdit.png'), //  会员-修改
  // ucDelete: require('../assets/icons/mamDelete.png'), //  会员-注销
  commandDelete: require('../assets/icons/mamDelete.png'), //  指令下达-删除
  commandEdit: require('../assets/icons/topicEdit.png'), //  指令下达-编辑
  foldIcon: require('../assets/icons/57.png'), //  指挥策划-折叠按钮-下箭头
  foldIconUp: require('../assets/icons/58.png'), //  指挥策划-折叠按钮-上箭头
  // QAPass: require('../assets/icons/discussPass.png'), //  问政-状态-通过
  // QAReject: require('../assets/icons/discussReject.png'), //  问政-不通过
  QAReplied: require('../assets/icons/discussReplied.png'), //  问政-官方回复-已回复
  // QAReply: require('../assets/icons/discussReply.png'), //  问政-官方回复
  deleteReplay: require('../assets/icons/deleteReplay.png'), //  问政-官方回复
  original: require('../assets/icons/original.png'), //  云端稿库-原创
  prohibition: require('../assets/icons/prohibition.png'), // 栏目树-禁止
  keyWithdrawal: require('../assets/icons/keyWithdrawal.png'), //  一键撤稿,
  // live: require('../assets/icons/59.png'), //  列表-直播
  // special: require('../assets/icons/60.png'), //  列表-专题
  // subject: require('../assets/icons/subject.png'), //  列表-话题
  // activity: require('../assets/icons/activity.png'), //  列表-活动
  // siteDetail: require('../assets/icons/siteDetail.png'), //  站点-查看授权清单
  // siteEdit: require('../assets/icons/siteEdit.png'), //  站点-修改
  // siteDelete: require('../assets/icons/siteDelete.png'), //  站点-删除
  // siteOpen: require('../assets/icons/siteOpen.png'), //  站点-启用
  // siteClose: require('../assets/icons/siteClose.png'), //  站点-禁用
  triangle: require('../assets/icons/triangle.png'), //  三角形
  userbarconfig: require('../assets/icons/config.png'), //  账户设置
  plus: require('../assets/icons/plus.png'), // 加号
  minus: require('../assets/icons/minus.png'), // 减号
  folder: require('../assets/icons/folder.png'), // 文件夹
  disable: require('../assets/icons/disable.png'), // 禁止
  // forbidden: require('../assets/icons/forbidden.png'),
  // startUsing: require('../assets/icons/startUsing.png'),
  // modification: require('../assets/icons/modification.png'),
  web: require('../assets/icons/web.png'),
  weixin: require('../assets/icons/weixin.png'),
  weibo_rootArticle: require('../assets/icons/weibo.png'),
  app_rootArticle: require('../assets/icons/APP.png'),
  // channelInfo: require('../assets/icons/channelInfo.png'),
  // flowRecord: require('../assets/icons/flowRecord.png'),
  channel: require('../assets/icons/channel.png'),
  setting: require('../assets/icons/setting.png'),
  refresh: require('../assets/icons/refresh.png'),
  reLogin: require('../assets/icons/reLogin.png'),
  weixinTick: require('../assets/icons/tick.png'),
  clock: require('../assets/icons/clock.png'),
  pageDelete: require('../assets/icons/page-delete.png'),
  // voteDelete: require('../assets/icons/comDelete.png'), // 投票-删除
  // voteEdit: require('../assets/icons/comEdit.png'), // 投票-修改
  // votePreview: require('../assets/icons/comPreview.png'), // 投票-预览
  // voteResult: require('../assets/icons/voteResult.png'), // 投票-投票结果
  // vote: require('../assets/icons/vote.png'),
  selectCurrent: require('../assets/icons/select_current.png'), // 稿源库中选中大图稿件，独家，关闭评论
  left_arrow_white: require('../assets/icons/left_arrow_white.png'),
  addImg: require('../assets/icons/adduserdefault.png'),
  // sort: require('../assets/icons/sort.png'), // 推荐管理——排序
  memIcon: require('../assets/icons/memIcon.png'), // 源稿库-送稿-人员图标
  perLine4: require('../assets/icons/perLine4.png'), // 栏目推荐-每行4个
  perLine3: require('../assets/icons/perLine3.png'), // 栏目推荐-每行3个
  perLine2: require('../assets/icons/perLine2.png'), // 栏目推荐-每行2个
  perLine1: require('../assets/icons/perLine1.png'), // 栏目推荐-每行1个
  paramsSetting: require('../assets/icons/paramsSetting.png'), // 栏目推荐-每行1个
  recovery: require('../assets/icons/recovery.png'), // 恢复
  // sen0: require('../assets/icons/sen0.png'), // 敏感词
  // sen1: require('../assets/icons/sen1.png'), // 禁用词
  // sen2: require('../assets/icons/sen2.png'), // 保留词
  circledClose: require('../assets/icons/circled-corss.png'), // 叉叉-关闭
  blueDelete: require('../assets/icons/blueDelete.png'), // 删除投票
  systemNotice: require('../assets/icons/system-notice.png'), // 系统公告
  // sensitive: require('../assets/icons/sensitive.png'), // 敏感词
  // illegal: require('../assets/icons/illegal.png'), // 禁用词
  // senandill: require('../assets/icons/senandill.png'), // 禁用词和敏感词
  // detail: require('../assets/icons/detail.png'), // 操作的详情图标
  activityResult: require('../assets/icons/activityResult.png'), // 活动列表查看报名图标
  up: require('../assets/icons/up.png'), // 小的向上的三角形
  down: require('../assets/icons/down.png'), // 小的向下的三角形
  remove: require('../assets/icons/icon-remove.png'), // 云端稿库移除
  move: require('../assets/icons/icon-move.png'), // 云端稿库移动
  closeImage: require('../assets/icons/closeImage.png'), // 微博-博文-删除图片
  weiboDefault: require('../assets/icons/weibo-default.png'), // 微博栏目-默认显示
  settingWhite: require('../assets/icons/setting-white.png'), // 白色的设置按钮
  // clue: require('../assets/icons/clue.png'), // 爆料转为线索

  folderWhite: require('../assets/icons/folder-white.png'),
  logo: require('../assets/icons/logo.png'),
  qie: require('../assets/icons/icon_qie.png'),
  third: require('../assets/icons/icon_third.png'),
  toutiao: require('../assets/icons/icon_toutiao.png'),
  baidu: require('../assets/icons/icon_baidu.png'),
  douyin: require('../assets/icons/icon_douyin.png'),

  // 编辑器-以图搜图
  enlarge: require('../assets/icons/enlarge.png'), // 放大
  exchange: require('../assets/icons/exchange.png'), // 替换

  // 线索汇聚
  cluesPt: require('../assets/icons/clues_pt.png'), // 普通
  cluesTf: require('../assets/icons/clues_tufa.png'), // 突发
  cluesZy: require('../assets/icons/clues_zy.png'), // 重要
  // mamQuickEdit: require('../assets/icons/quickEdit.png'), // 快编
  print: require('../assets/icons/63.png'), // 打印
  export: require('../assets/icons/64.png'), // 导出
  // 抖音稿件列表
  // trRefresh: require('../assets/icons/tr-refresh.png'), // table里的刷新

  cover: require('../assets/icons/65.png'), // 封面
  coverDelete: require('../assets/icons/66.png'), // 删除封面
  videoWarning: require('../assets/icons/67.png'), // 视频详情中的叹号
  questionMark: require('../assets/icons/questionMark.png'), // 媒资库-智能检测-疑似
  exclamationMark: require('../assets/icons/exclamationMark.png') // 媒资库-智能检测-违规 */
  error2: require('../assets/icons/error2.png') //图片上产失败时展示
}
function getBase64Image(img) {
  var canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height
  var ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, img.width, img.height)
  var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
  var dataURL = canvas.toDataURL('image/' + ext)
  return dataURL
}
//延后两秒执行，避免阻塞
setTimeout(()=>{
  Object.keys(icons).forEach((key) => {
    var image = new Image()
    image.src = icons[key]
    image.onload = function() {
      icons[key] = getBase64Image(image)
    }
  })
},2000)

export default icons
